import Script from "next/script";

type StructuredDataProps = {
  type: "organization" | "software" | "faq" | "article";
  data?: Record<string, unknown>;
};

export function StructuredData({ type, data }: StructuredDataProps) {
  const getSchema = () => {
    switch (type) {
      case "organization":
        return {
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Tavlo",
          url: "https://tavlo.ca",
          logo: "https://tavlo.ca/logo-light.png",
          description:
            "Personal second brain for social media content. Save, organize, and resurface valuable content from Twitter, LinkedIn, Instagram, YouTube, and more.",
          sameAs: [
            "https://twitter.com/tavlofounder",
            "https://www.linkedin.com/company/tavlo",
          ],
          foundingDate: "2024",
          slogan: "Your Personal Second Brain for Social Media",
        };

      case "software":
        return {
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          name: "Tavlo",
          applicationCategory: "ProductivityApplication",
          operatingSystem: "Web, Chrome Extension",
          offers: {
            "@type": "Offer",
            price: "0",
            priceCurrency: "USD",
            description: "Free during beta period",
          },
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "5.0",
            ratingCount: "6",
            reviewCount: "6",
          },
          description:
            "Transform how you capture, organize, and repurpose content from across the web. Tavlo helps creators and professionals build their second brain for social media, newsletters, and more.",
          screenshot: "https://tavlo.ca/og-image.png",
          featureList: [
            "AI-powered content summaries",
            "Smart automatic tagging",
            "Multi-platform support (8+ platforms)",
            "Calm replay feed",
            "Powerful search across all saved content",
            "Privacy-first architecture",
            "Chrome extension for easy saving",
            "Unified library across Twitter, LinkedIn, Instagram, YouTube, Reddit, TikTok, and more",
          ],
        };

      case "faq":
        return data || {};

      case "article":
        return data || {};

      default:
        return {};
    }
  };

  const schema = getSchema();

  return (
    <Script
      id={`structured-data-${type}`}
      type="application/ld+json"
      strategy="afterInteractive"
    >
      {JSON.stringify(schema)}
    </Script>
  );
}
